<template>
    <ui-modal
        :icon-circle="true"
        title="Cancelar Reserva"
        icon="fal fa-grip-horizontal"
        name="cancel-reservation">

        <div class="container-cancel-reservation-modal">
            <div class="header">
                <div class="header-title">Tem certeza que deseja cancelar as Reserva #{{reservation ? reservation.id : '0'}}?</div>

                <div class="header-subtitle">Esta ação não poderá ser desfeita</div>
            </div>

            <div class="footer">
                <ui-button
                    :disabled="loading"
                    design="md mw-150 success"
                    @click="actionHandler('no')">
                    Não
                </ui-button>

                <ui-button
                    :loading="loading"
                    design="md mw-150 danger"
                    @click="actionHandler('yes')">
                    Sim
                </ui-button>
            </div>
        </div>
    </ui-modal>
</template>

<script>
    import { uiModal } from "@/components/ui/modal"
    import { uiButton } from '@/components/ui/buttons'

    import { reserve } from '@/services/axios'

    export default {
        name: 'cancel-reservation-modal',

        components: {
            uiModal,
            uiButton,
        },

        data() {
            return {
                reservation: null,
                loading: false
            }
        },

        mounted() {
            this.$root.$on('modal-open-cancel-reservation', payload => {
                this.reservation = { ...payload }
            })
        },

        beforeDestroy() {
            this.reservation = null
            this.$root.$off('modal-open-cancel-reservation')
        },

        methods: {
            /**
             * Event handler que trata a resposta do usuário acerca do cancelamento da
             * reserva
             */
            actionHandler: async function (action) {
                if (action === 'yes') {
                    this.loading = true
                    const params = {
                        id: this.reservation.id,
                        expire_time: '00:00:00',
                        reason: '',
                        status: 'canceled'
                    }
                    await reserve.updateV2('', this.reservation.id, { ...params })
                        .then(response => {
                            if (response.data.msg) this.$toastr.s(response.data.msg)
                        })
                        .catch(error => {
                            if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
                        })
                        .finally(() => {
                            this.loading = false
                        })
                }

                this.$root.$emit('modal-close-cancel-reservation')
            }
        }
    }
</script>

<style lang="stylus" scoped>
    @import './styles.styl';
</style>